import { accountTypes } from '../Share/SocialAccountsSelector'

export const assetsForFile = (file, providers) => {
  switch(file.type) {
    case 'graphic':
      return file.attributes.formats.map(format => {

        return {
          key: ["graphic", file.id, format.id].join('-'),
          format: format.id,
          id: file.id,
          type: 'graphic',
          name: format.title,
          story: format.story,
          previewUrl: file.attributes.preview_urls[format.id],
          enabledActions: providersForGraphicFormat(format, providers).map(provider => actionForProvider(provider, format.story))
        }
      })
    case 'upload':
      return [{
        key: ["upload", file.id].join('-'),
        id: file.id,
        type: 'upload',
        name: file.attributes.filename,
        previewUrl: file.attributes.thumb_url,
        enabledActions: providers.map(provider => actionForProvider(provider, false))
      }]
  }
}

const providersForGraphicFormat = (format, providers) => {
  const storyProviders = providers.filter(provider => accountTypes[provider].supports_story)

  if (format.story) return storyProviders
  if (format.social === 'all') return providers

  return format.social
    .split(',')
    .map(p => p.trim())
    .filter(provider => providers.includes(provider))
}

export const actionForProvider = (provider, story) => {
  const accountType = accountTypes[provider]
  const verb = story ? 'Story' : accountType.action

  return {
    provider,
    story: story,
    key: [provider, verb.toLowerCase()].join('-'),
    name: [accountType.label, verb].join(' ')
  }
}

export const actionsForProvider = (provider) => {
  const accountType = accountTypes[provider]
  const actions = [actionForProvider(provider, false)]

  if (accountType.supports_story) {
    actions.push(actionForProvider(provider, true))
  }

  return actions
}